import { render, staticRenderFns } from "./Lesenphants.vue?vue&type=template&id=9fcb1a32&scoped=true&"
import script from "./Lesenphants.vue?vue&type=script&lang=js&"
export * from "./Lesenphants.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fcb1a32",
  null
  
)

export default component.exports